import { DialogRef } from '@angular/cdk/dialog';
import { CommonModule } from '@angular/common';
import {
  Component, HostBinding, inject, input, output,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { filter } from 'rxjs';

import { ButtonCloseComponent } from '../button-close/button-close.component';
import { InlineSvgComponent } from '../inline-svg/inline-svg.component';


@Component({
  selector: 'ui-modal',
  imports: [ CommonModule, ButtonCloseComponent, InlineSvgComponent ],
  templateUrl: './modal.component.html',
  styleUrl: './modal.component.scss',
})
export class ModalComponent {
  /** The background color of the modal. */
  backgroundColor = input<'default' | 'gray' | 'blue'>('default');

  /** Align the modal content to its center. */
  centered = input<boolean>(false);

  /** The SVG icon to be displayed in the modal's title. */
  titleIcon = input<string>();

  /** Sets a loading state, disabling interactions with the modal content. */
  loading = input<boolean>(false);

  /** Sets the width of the modal (e.g., '50vw', '70vw', '600px' etc.). */
  modalWidth = input<string>('50vw');

  /**
   * Emitted when the × button, backdrop click, or Escape key requests a close
   * and `dialogRef.disableClose` is true. The consumer is responsible for
   * deciding whether and when to close the dialog.
   */
  closeRequested = output<void>();

  /** A reference to the dialog service managing this modal. */
  private dialogRef = inject(DialogRef);

  @HostBinding('style.width') get hostWidth(): string {
    return this.modalWidth();
  }

  constructor() {
    this.dialogRef.backdropClick
      .pipe(takeUntilDestroyed())
      .subscribe(() => this.onClose());

    this.dialogRef.keydownEvents
      .pipe(
        filter((event: KeyboardEvent) => event.key === 'Escape'),
        takeUntilDestroyed(),
      )
      .subscribe(() => this.onClose());
  }

  /** Closes the modal dialog, or emits closeRequested if disableClose is set. */
  onClose(): void {
    if (this.dialogRef.disableClose) {
      this.closeRequested.emit();

      return;
    }
    this.dialogRef.close();
  }
}
